export default __webpack_public_path__ + "static/ClarityNuvo-Bold-ae904e233f50031132e0460728406eeb.woff2";